'use strict';
import { observeAddToCartButtons } from "../add-to-cart.js";

class AccountData {

    
    constructor(order_by, order, container, type) {
        this._container = document.getElementById(container);
        this._self = this;
        this._order_by = order_by;
        this._order = order;
        this._per_page = 1;
        this._page = 0;
        this._type = type;
        
        this._loading = document.getElementById('account-loading');

        if (this._type === 'orders') {
            this._rowsEl = document.getElementById('user-orders-rows');
            this._rowTemplate = document.getElementById('user-order-template');
            this._rowHeadersTemplate = document.getElementById('user-order-headers');
            this._noneTemplate = document.getElementById('user-orders-none');
            this._rowExpandable = document.getElementById('user-order-details');
            this._orders = this.getOrders();
        } else if (this._type === 'products') {
            this._rowsEl = document.getElementById('user-products-rows');
            this._rowTemplate = document.getElementById('user-product-template');
            this._noneTemplate = document.getElementById('user-products-none');
            this._products = this.getProducts();
        }
    }

    get products() {
        return this._products;
    }

    /**
     * @param {string} order_by
     */
    set order_by(order_by) {
        if(order_by == this._order_by) return;
        this._order_by = order_by;
        this._products = this.getProducts();
    }

    /**
     * @param {string} order
     */
    set order(order) {
        if(order == this._order) return;
        this._order = order;
        this._products = this.getProducts();
    }

    /**
     * @param {array} ordering
     */
    set ordering(ordering) {
        this._order_by = ordering.order_by;
        this._order = ordering.order;
        this.getProducts();
    }

    async getProducts() {
        try {
            this._products = await jQuery.ajax({
                type: "POST",
                dataType: "json",
                url: ajax_var.url,
                data: {
                    action: "get_current_user_products",
                    order_by: this._order_by,
                    order: this._order,
                    per_page: this._per_page,
                    page: this._page,
                    nonce: ajax_var.nonce
                }
            } ).done(function(response) {
                this.render(response, 'products')
                return response;
            }.bind(this));
        } catch (error) {
            console.error(error);
        }
    }

    async getOrders() {
        try {
            this._orders = await jQuery.ajax({
                type: "POST",
                dataType: "json",
                url: ajax_var.url,
                data: {
                    action: "get_current_user_orders",
                    order_by: this._order_by,
                    order: this._order,
                    per_page: this._per_page,
                    page: this._page,
                    nonce: ajax_var.nonce
                }
            } ).done(function(response) {
                console.log(response)
                this.render(response, 'orders')
                return response;
            }.bind(this));
        } catch (error) {
            console.error(error);
        }
    }

    async getOrder(id) {
        try {
            this._orders = await jQuery.ajax({
                type: "POST",
                dataType: "json",
                url: ajax_var.url,
                data: {
                    action: "get_current_user_order",
                    id: id,
                    nonce: ajax_var.nonce
                }
            } ).done(function(response) {
                this.render(response.data, 'order')
                return response;
            }.bind(this));
        } catch (error) {
            console.error(error);
        }
    }

    async render(response, type) {

        if (!'content' in document.createElement('template')) {
            console.log('Internet Explorer does not support template elements, cannot display products.')
            return;
        }

        if (type && type == 'products') {

            response = response ? response : this._products
            this._rowsEl.innerHTML = '';

            if(!response || response.length == 0) {
                return this._rowsEl.appendChild(
                    this._noneTemplate.content.cloneNode(true)
                );
            }
            
            Promise.all(response.data).then( results => {
                results.forEach(result => {
                    var clone = this._rowTemplate.content.cloneNode(true);

                    clone.querySelectorAll(".user-product-link")[0].setAttribute('href', result.permalink);
                    clone.querySelectorAll(".user-product-name")[0].textContent = result.name;
                    clone.querySelectorAll(".user-product-thumbnail")[0].src = result.thumbnail;
                    clone.querySelectorAll(".user-product-sku")[0].textContent = result.sku;
                    clone.querySelectorAll(".user-product-quantity")[0].textContent = result.quantity;
                    clone.querySelectorAll(".user-product-quantity")[1].textContent = result.quantity;
                    clone.querySelectorAll(".user-product-purchase_date")[0].textContent = result.purchase_date_formatted;
                    
                    this._rowsEl.appendChild(clone);
                })
            });
            

        } else if (type && type == 'orders') {

            response = response ? response : this._orders
            this._rowsEl.innerHTML = '';

            if(!response || response.length == 0) {
                return this._rowsEl.appendChild(
                    this._noneTemplate.content.cloneNode(true)
                );
            }

            Promise.all(response.data).then( results => {
                if(!results || results.length == 0) {
                    return this._rowsEl.appendChild(
                        this._noneTemplate.content.cloneNode(true)
                    );
                }
                results.forEach(result => {
                    var clone = this._rowTemplate.content.cloneNode(true);

                    clone.querySelectorAll(".user-order-id")[0].textContent = result.id;
                    clone.querySelectorAll(".user-order-date")[0].textContent = result.date;
                    clone.querySelectorAll(".user-order-status")[0].textContent = result.status_label;
                    clone.querySelectorAll(".user-order-cost")[0].textContent = result.cost;
                    clone.querySelectorAll(".user-order-quantity")[0].textContent = result.quantity;
                    clone.querySelectorAll(".user-order-summary")[0].id = 'user-order-summary-'+result.id;
                    clone.querySelectorAll(".user-order-summary")[0].dataset.id = result.id;
                    clone.querySelectorAll(".user-order-expandable")[0].id = 'user-order-expandable-'+result.id;

                    this._rowsEl.appendChild(clone);

                    document.getElementById('user-order-summary-'+result.id).addEventListener('click', function(e) {
                        let summary = null;

                        if (e.srcElement.classList.contains('user-order-summary')) {
                            summary = e.srcElement;
                        } else {
                            summary = e.srcElement.closest('.user-order-summary');
                        }

                        let id = summary.dataset.id;
                        let expandable = document.getElementById('user-order-expandable-'+id);
                        let loaded = expandable.classList.contains('loaded');
                        let expanded = expandable.classList.contains('expanded');
                        let chevron = summary.querySelectorAll(".user-order-chevron")[0];

                        const chevronClasses = ['rotate-180'];
                        const summaryClasses = ['expanded', 'bg-versa-100', 'font-semibold'];


                        if (!expanded) {

                            if (!loaded) {
                                summary.classList.add('loading');
                                this.getOrder(result.id);
                            }
                            chevron.classList.add(...chevronClasses)
                            summary.classList.add(...summaryClasses)
                            expandable.classList.add('max-h-full')
                            expandable.classList.remove('max-h-0');
                            expandable.classList.add('expanded');
                        } else {
                            chevron.classList.remove(...chevronClasses)
                            summary.classList.remove(...summaryClasses)
                            expandable.classList.remove('max-h-full')
                            expandable.classList.add('max-h-0')
                            expandable.classList.remove('expanded');
                        }
                    }.bind(this));

                })
            });

        } else if (type && type == 'order') {
            Promise.all(response).then( result => {
                result = result[0];
                const expandableEl = document.getElementById('user-order-expandable-'+result.id);
                expandableEl.innerHTML = '';
                expandableEl.appendChild(this._rowHeadersTemplate.content.cloneNode(true))
                const productRowsEl = expandableEl.querySelectorAll('.user-order-products')[0]
                
                if (expandableEl.classList.contains('loaded')) return;



                // ----------- Items Start -----------
                result.items.forEach(item => {
                    var productTemplate = document.getElementById('user-order-product').content.cloneNode(true);
                    productTemplate.querySelectorAll(".user-order-product-name")[0].textContent = item.name;
                    productTemplate.querySelectorAll(".user-order-product-url")[0].href = item.url;
                    productTemplate.querySelectorAll(".user-order-product-sku")[0].textContent = 'Art. nr. ' + item.sku;
                    productTemplate.querySelectorAll(".user-order-product-quantity")[0].textContent = item.quantity + ' st';
                    productTemplate.querySelectorAll(".user-order-product-quantity")[1].textContent = item.quantity + ' st';

                    var subtotalParsed = (new DOMParser()).parseFromString(item.sub_formatted, 'text/html').documentElement;
                    productTemplate.querySelectorAll(".user-order-product-subtotal_with_tax")[0].appendChild(subtotalParsed.querySelector('body > *'));

                    var subtotalPerQtyParsed = (new DOMParser()).parseFromString(item.sub_formatted_per_qty, 'text/html').documentElement;
                    productTemplate.querySelectorAll(".user-order-product-subtotal_with_tax_per_qty")[0].appendChild(subtotalPerQtyParsed.querySelector('body > *'));

                    let thumbnail = item.thumbnail;
                    var thumbnailParsed = (new DOMParser()).parseFromString(thumbnail, 'text/html').querySelector('img');
                    let thumbnailEl = productTemplate.querySelectorAll(".user-order-product-thumbnail")[0];
                    thumbnailEl.src = thumbnailParsed.src;
                    thumbnailEl.alt = thumbnailParsed.alt;
                    thumbnailEl.srcset = thumbnailParsed.srcset;
                    thumbnailEl.height = thumbnailParsed.height;
                    thumbnailEl.width = thumbnailParsed.width;
                    thumbnailEl.sizes = thumbnailParsed.sizes;
                    thumbnailEl.loading = thumbnailParsed.loading;


                    // ----------- Current Price Start -----------
                    var currentPriceParsed = (new DOMParser()).parseFromString(item.current_price_formatted, 'text/html').documentElement;
                    productTemplate.querySelectorAll(".user-order-product-current-price")[0].insertAdjacentHTML('beforeend', currentPriceParsed.querySelector('body').innerHTML);
                        

                    // ----------- Current Price End -----------


                    // ----------- Add to cart buttons Start -----------

                    if (item.is_purchasable) {
                        var addToCartButtonTemplate = document.getElementById('add-to-cart-button-in-stock-template').content.cloneNode(true);
                    } else if (item.allow_backorders) {
                        var addToCartButtonTemplate = document.getElementById('add-to-cart-button-backorder-template').content.cloneNode(true);
                    } else {
                        var addToCartButtonTemplate = document.getElementById('add-to-cart-button-out-of-stock-template').content.cloneNode(true);
                    }

                    addToCartButtonTemplate.querySelectorAll(".add_to_cart_button").forEach( (el) => {
                        el.dataset.product_id = item.id
                        el.dataset.variation_id = item.variation_id
                        el.value = item.id
                        el.dataset.sku = item.sku
                    });

                    productTemplate.querySelectorAll(".user-order-product-add-to-cart-button")[0].appendChild(addToCartButtonTemplate);

                    // ----------- Add to cart buttons End -----------


                    productRowsEl.appendChild(productTemplate);

                });

                expandableEl.classList.remove('loading');
                expandableEl.classList.add('loaded');
                expandableEl.appendChild(productRowsEl);
                // ----------- Items End -----------

                // ----------- Costs Start -----------
                    var costsTemplate = document.getElementById('user-order-costs').content.cloneNode(true);


                    // ----------- Subtotal Start -----------

                    if (result.formatted_subtotal) {
                        var subtotalCostTemplate = document.getElementById('user-order-cost-subtotal').content.cloneNode(true);
                        var subtotalCostParsed = (new DOMParser()).parseFromString(result.formatted_subtotal, 'text/html').documentElement;
                        subtotalCostTemplate.querySelectorAll(".user-order-cost-subtotal-total")[0].appendChild(subtotalCostParsed.querySelector('body > *'));
                        subtotalCostTemplate.querySelectorAll(".user-order-cost-subtotal-label")[0].textContent = result.quantity;
                        costsTemplate.querySelectorAll(".user-order-costs-summary")[0].appendChild(subtotalCostTemplate);
                        productRowsEl.appendChild(subtotalCostTemplate);
                    }
                    
                    // ----------- Subtotal End -----------


                    // ----------- Coupons Start -----------

                    if (result.coupons && result.coupons.length > 0) {

                        var discountsTemplate = document.getElementById('user-order-cost-coupon').content.cloneNode(true);
                        var discountLines = discountsTemplate.querySelectorAll('.user-order-cost-coupon-list')[0];

                        result.coupons.forEach(item => {
                            var discountLineTemplate = document.getElementById('user-order-cost-coupon-line').content.cloneNode(true);



                            discountLineTemplate.querySelectorAll(".user-order-cost-coupon-label")[0].textContent = item.code;

                            var totalParsed = (new DOMParser()).parseFromString(item.discount_formatted, 'text/html').documentElement;
                            discountLineTemplate.querySelectorAll(".user-order-cost-coupon-total")[0].appendChild(totalParsed.querySelector('body > *'));

                            discountLines.appendChild(discountLineTemplate);

                        });

                        costsTemplate.querySelectorAll(".user-order-costs-summary")[0].appendChild(discountsTemplate);

                    }
                    // ----------- Coupons End -----------


                    // ----------- Fees Start -----------

                    if (result.fees && result.fees.length > 0) {

                        var feesTemplate = document.getElementById('user-order-cost-fee').content.cloneNode(true);
                        var feeLines = feesTemplate.querySelectorAll('.user-order-cost-fee-list')[0];

                        result.fees.forEach(item => {
                            var feeLineTemplate = document.getElementById('user-order-cost-fee-line').content.cloneNode(true);



                            feeLineTemplate.querySelectorAll(".user-order-cost-fee-label")[0].textContent = item.name;

                            var totalParsed = (new DOMParser()).parseFromString(item.fee_formatted, 'text/html').documentElement;
                            feeLineTemplate.querySelectorAll(".user-order-cost-fee-total")[0].appendChild(totalParsed.querySelector('body'));
                            
                            feeLines.appendChild(feeLineTemplate);

                        });

                        costsTemplate.querySelectorAll(".user-order-costs-summary")[0].appendChild(feesTemplate);

                    }
                    // ----------- Fees End -----------


                    // ----------- Shipping cost Start -----------

                    if (result.shipping_cost_formatted) {
                        var shippingCostTemplate = document.getElementById('user-order-cost-shipping').content.cloneNode(true);
                        var shippingCostParsed = (new DOMParser()).parseFromString(result.shipping_cost_formatted, 'text/html').documentElement;
                        shippingCostTemplate.querySelectorAll(".user-order-cost-shipping-total")[0].insertAdjacentHTML('beforeend', shippingCostParsed.querySelector('body').innerHTML);
                        costsTemplate.querySelectorAll(".user-order-costs-summary")[0].appendChild(shippingCostTemplate);
                        productRowsEl.appendChild(shippingCostTemplate);
                    }
                    
                    // ----------- Shipping cost End -----------


                    // ----------- Refunds Start -----------

                    if (result.refunds) {
                        result.refunds.forEach(item => {
                            var costTemplate = document.getElementById('user-order-cost-credit').content.cloneNode(true);
                            
                            costTemplate.querySelectorAll(".user-order-cost-credit-date")[0].textContent = item.date_formatted;

                            var totalParsed = (new DOMParser()).parseFromString(item.total_with_tax_formatted, 'text/html').documentElement;
                            costTemplate.querySelectorAll(".user-order-cost-credit-total")[0].insertAdjacentHTML('beforeend', totalParsed.querySelector('body').innerHTML);

                            costsTemplate.querySelectorAll(".user-order-costs-summary")[0].appendChild(costTemplate);

                        });
                    }

                    // ----------- Refunds End -----------


                    // ----------- Discount Start -----------

                    if (result.discount_formatted) {
                        var discountTemplate = document.getElementById('user-order-cost-discount').content.cloneNode(true);
                        var discountParsed = (new DOMParser()).parseFromString(result.discount_formatted, 'text/html').documentElement;
                        var discountTaxParsed = (new DOMParser()).parseFromString(result.discount_tax_formatted, 'text/html').documentElement;
                        discountTemplate.querySelectorAll(".user-order-cost-discount-total")[0].insertAdjacentHTML('beforeend', discountParsed.querySelector('body').innerHTML);
                        costsTemplate.querySelectorAll(".user-order-costs-summary")[0].appendChild(discountTemplate);
                        productRowsEl.appendChild(discountTemplate);
                    }
                    
                    // ----------- Discount End -----------


                    // ----------- Total cost Start -----------

                    if (result.formatted_order_total) {
                        var totalCostTemplate = document.getElementById('user-order-cost-total').content.cloneNode(true);
                        var totalCostParsed = (new DOMParser()).parseFromString(result.formatted_order_total, 'text/html').documentElement;
                        totalCostTemplate.querySelectorAll(".user-order-cost-total-total")[0].insertAdjacentHTML('beforeend', totalCostParsed.querySelector('body').innerHTML);
                        costsTemplate.querySelectorAll(".user-order-costs-summary")[0].appendChild(totalCostTemplate);
                        productRowsEl.appendChild(totalCostTemplate);
                    }
                    
                    // ----------- Total cost End -----------

                    productRowsEl.appendChild(costsTemplate);

                // ----------- Costs End -----------

                

                // ----------- Details Start -----------
                const detailsEl = expandableEl.querySelectorAll('.user-order-details')[0]
                var detailsTemplate = document.getElementById('user-order-details').content.cloneNode(true);

                detailsTemplate.querySelectorAll(".user-order-shipping-method")[0].textContent = result.shipping_custom_title;
                detailsTemplate.querySelectorAll(".user-order-shipping-company")[0].textContent = result.shipping_company;

                if (result.shipping_tracking) {
                    detailsTemplate.querySelectorAll(".user-order-tracking")[0].textContent = result.shipping_tracking;
                    detailsTemplate.querySelectorAll(".user-order-tracking-button")[0].href += result.shipping_tracking;
                    detailsTemplate.querySelectorAll(".user-order-tracking-button")[0].classList.remove('hidden');
                }
                detailsTemplate.querySelectorAll(".user-order-id")[0].textContent = result.id;
                detailsTemplate.querySelectorAll(".user-order-status")[0].textContent = result.status_label;
                detailsTemplate.querySelectorAll(".user-order-payment-method")[0].textContent = result.payment_method_label;
                detailsTemplate.querySelectorAll(".user-order-payment-transaction-id")[0].textContent = result.payment_transaction_id;

                if (result.payment_method_label.includes('Faktura')) {
                    detailsTemplate.querySelectorAll(".user-order-payment-method-invoice")[0].classList.remove('hidden');
                }

                var billingAddressParsed = (new DOMParser()).parseFromString(result.billing_address, 'text/html').documentElement;
                detailsTemplate.querySelectorAll(".user-order-billing-address")[0].appendChild(billingAddressParsed.querySelector('body'));

                var shippingAddressParsed = (new DOMParser()).parseFromString(result.shipping_address, 'text/html');
                detailsTemplate.querySelectorAll(".user-order-shipping-address")[0].appendChild(shippingAddressParsed.querySelector('body'));

                detailsEl.appendChild(detailsTemplate);
                // ----------- Details End -----------



                // ----------- Info Start -----------
                const infoEl = expandableEl.querySelectorAll('.user-order-info')[0];
                var infoTemplate = document.getElementById('user-order-info').content.cloneNode(true);
                var infoTemplateMessageEl = infoTemplate.querySelectorAll('.user-order-info-message')[0];
                if (result.status === 'cancelled') {
                    infoTemplateMessageEl.appendChild(document.getElementById('user-order-info-cancelled').content.cloneNode(true));
                } else if (result.status === 'processing') {
                    infoTemplateMessageEl.appendChild(document.getElementById('user-order-info-processing').content.cloneNode(true));
                } else if (result.status === 'completed') {
                    infoTemplateMessageEl.appendChild(document.getElementById('user-order-info-completed').content.cloneNode(true));
                } else if (result.status === 'refunded') {
                    infoTemplateMessageEl.appendChild(document.getElementById('user-order-info-refunded').content.cloneNode(true));
                } else if (result.status === 'pending') {
                    infoTemplateMessageEl.appendChild(document.getElementById('user-order-info-pending').content.cloneNode(true));
                }

                infoEl.appendChild(infoTemplate);
                // ----------- Info End -----------




                expandableEl.appendChild(detailsTemplate);

                observeAddToCartButtons();
                


            });
        }
    }


}

if (window.location.href.includes('/my-account/products')) {
    (function () {
        const sortEl = document.getElementById('user-products-order')
        const userProducts =  new AccountData('name', 'desc', 'user-products', 'products');

        if (sortEl) {
            sortEl.addEventListener('input', function (event) {
                const selection = this.value.split('-');
                userProducts.ordering = {order_by: selection[0], order: selection[1]}
            }, false);
        }
    })();
}

if (window.location.href.includes('/my-account/orders')) {
    (function () {
        const sortEl = document.getElementById('user-orders-order')
        const userProducts =  new AccountData('name', 'desc', 'user-orders', 'orders');

        if (sortEl) {
            sortEl.addEventListener('input', function (event) {
                const selection = this.value.split('-');
                userProducts.ordering = {order_by: selection[0], order: selection[1]}
            }, false);
        }
    })();
}